export const UPLOAD_STOREY_ANNOTATION_FILE_SUCCESS = 'UPLOAD_STOREY_ANNOTATION_FILE_SUCCESS';
export const UPLOAD_ANNOTATION_FILE_SUCCESS = 'UPLOAD_ANNOTATION_FILE_SUCCESS';
export const AGENT_RETURN_PLAN_ORDER_SUCCESS = 'AGENT_RETURN_PLAN_ORDER_SUCCESS';
